import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import SeguroService from "../../../../services/seguro";
import { CODES } from "../../../../utils/responseCodes";
import { simpleAlerts } from "../../../../utils/alerts";
import SpinnerLoader from "../../../components/SpinnerLoad/SpinnerLoader";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BodyDeclaracion from "../../../components/Seguros/BodyDeclaracion/BodyDeclaracion";

const DeclaracionAseguradora = () => {
  const [titleSpinner, setTitleSpinner] = useState(null);
  const [openModalLoader, setOpenModalLoader] = useState(true);
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    getHistorial();
  }, []);

  const getHistorial = async () => {
    setOpenModalLoader(true);
    setTitleSpinner("Cargando historial...");

    await SeguroService.getHistorialTramites()
      .then((result) => {
        if (result.status === CODES.SUCCESS_200) {
          setHistorial(result.data || []);
        } else {
          simpleAlerts("Hubo un error al obtener el historial", "error");
        }
      })
      .catch((err) => {
        console.log("getHistorialTramites", err);
        simpleAlerts("Hubo un error al obtener el historial", "error");
      })
      .finally(() => setOpenModalLoader(false));
  };

  const consultarEstadoApi = async (tramiteId_api) => {
    setOpenModalLoader(true);
    setTitleSpinner("Consultando a la Aseguradora...");

    await SeguroService.consultarConstancias(tramiteId_api)
      .then((result) => {
        if (result.status === CODES.SUCCESS_200) {
          const data = result.data;
          
          if (data.estado_api === 'CONSTANCIAS_DISPONIBLES') {
            simpleAlerts("¡Los PDFs ya están listos!", "success");
            getHistorial(); // Refrescar la tabla
            
            // Si la API trae los PDFs en base64, los descargamos[cite: 1]
            if (data.constancias && data.constancias.length > 0) {
              descargarPdfs(data.constancias);
            }
          } else {
            simpleAlerts(`El trámite sigue: ${data.estado_api}`, "warning");
          }
        } else {
          simpleAlerts("Hubo un error al consultar el estado", "error");
        }
      })
      .catch((error) => {
        console.log("consultarConstancias", error);
        simpleAlerts("Hubo un error al consultar a la aseguradora", "error");
      })
      .finally(() => setOpenModalLoader(false));
  };

  const descargarPdfs = (constancias) => {
    constancias.forEach((pdf) => {
      const linkSource = `data:${pdf.mimeType};base64,${pdf.contenidoBase64}`;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = pdf.nombreArchivo;
      downloadLink.click();
    });
  };

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Grid container justifyContent="center" mb={2} alignItems="center">
        <Grid item xs={12} md={10} display="flex" justifyContent="space-between">
          <Typography variant="h5" fontWeight="bold">
            Historial de Declaraciones a Aseguradora
          </Typography>
          <Button 
            variant="outlined" 
            color="primary" 
            startIcon={<AutorenewIcon />} 
            onClick={getHistorial}
          >
            Actualizar Tabla
          </Button>
        </Grid>
      </Grid>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={10}>
          <BodyDeclaracion
            historial={historial}
            onConsultar={consultarEstadoApi}
          />
        </Grid>
      </Grid>

      <SpinnerLoader open={openModalLoader} title={titleSpinner} />
    </Box>
  );
};

export default DeclaracionAseguradora;